import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/HomeWorkOrderDefaults'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class HomeWorkOrderDefaultsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "HomeWorkOrderDefaultsStore",
			variables: false,
		})
	}
}

export async function load_HomeWorkOrderDefaults(params) {
  await initClient()

	const store = new HomeWorkOrderDefaultsStore()

	await store.fetch(params)

	return {
		HomeWorkOrderDefaults: store,
	}
}
